export default "__VITE_ASSET__BUDvoW3R__"